// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/marks-display-requirement.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/marks-display-requirement/marks-display-requirement.js';

mount([g0]);
